import SimpleHeader from "../SimpleHeader/SimpleHeader";

const TransactionsHeader = () => <SimpleHeader title="Transactions Items" borderBottom />;

export default TransactionsHeader;
